import { render, staticRenderFns } from "./GlobalNotice.vue?vue&type=template&id=0cf48c6f&scoped=true&"
import script from "./GlobalNotice.vue?vue&type=script&lang=js&"
export * from "./GlobalNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf48c6f",
  null
  
)

export default component.exports